function format(str: string, ...values: any[]): string {
    return str.replace(/\{(\d+)\}/g, function (_match, index) {
        if (values.length > index) {
            return values[index];
        } else {
            return "";
        }
    });
}

export { format };
